import { render, staticRenderFns } from "./CCaseNumber.vue?vue&type=template&id=3723c88a&scoped=true&"
import script from "./CCaseNumber.vue?vue&type=script&lang=js&"
export * from "./CCaseNumber.vue?vue&type=script&lang=js&"
import style0 from "./CCaseNumber.vue?vue&type=style&index=0&id=3723c88a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3723c88a",
  null
  
)

export default component.exports